import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/tabs'
import $ from 'jquery'

class InfoTabs {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)

    this.initTabs()
  }

  initTabs() {
    this.wrap.tabs()
  }
}
export default InfoTabs
